import { Injectable } from '@angular/core';
import { LocalStorageKeys } from 'src/app/enum/local-storage-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  /**
   * Guardar un valor en localStorage con una clave específica.
   */
  set<T>(key: LocalStorageKeys, value: T): void {
    try {
      if (typeof value === 'undefined') {
        return;
      }

      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      // Silent error handling
    }
  }


  get<T>(key: LocalStorageKeys): T | null {
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      // Intenta parsear el valor
      return JSON.parse(item) as T;
    } catch (error) {
      return item as unknown as T;
    }
  }

  /**
   * Eliminar un valor desde localStorage.
   */
  remove(key: LocalStorageKeys): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // Silent error handling
    }
  }

  /**
   * Limpiar todos los valores de localStorage.
   */
  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      // Silent error handling
    }
  }

  /**
   * Verifica si existe una clave en localStorage.
   */
  exists(key: LocalStorageKeys): boolean {
    return localStorage.getItem(key) !== null;
  }
}
